import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { useState } from "react";

function Navbar() {
  const { token, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const isActive = (path) => location.pathname === path;

  const linkClass = (path) =>
    [
      "transition text-sm",
      isActive(path)
        ? "text-indigo-600 font-semibold"
        : "text-slate-700 hover:text-indigo-600",
    ].join(" ");

  return (
    <nav className="bg-white/90 backdrop-blur border-b border-slate-200 sticky top-0 z-40">
      <div className="max-w-8xl mx-auto px-4 py-0 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center h-[72px] flex-col justify-center gap-0.5">
          <img
            src="/assets/blackoutgames.png"
            alt="Blackout Games"
            className="h-8 w-auto object-contain"
          />
          <span className="hidden sm:inline text-[11px] font-semibold tracking-widest text-slate-400 uppercase">
            Games
          </span>
        </Link>

        {/* Menu desktop */}
        <div className="hidden md:flex items-center gap-1">
          {/* Nav principale */}
          <div className="flex items-center gap-1 mr-2">
            <Link to="/" className={`px-3 py-2 rounded-lg ${linkClass("/")}`}>
              Accueil
            </Link>
            <Link to="/catalogue" className={`px-3 py-2 rounded-lg ${linkClass("/catalogue")}`}>
              Catalogue
            </Link>
            <Link to="/offres" className={`px-3 py-2 rounded-lg ${linkClass("/offres")}`}>
              Tarifs
            </Link>
            <Link to="/guide" className={`px-3 py-2 rounded-lg ${linkClass("/guide")}`}>
              Guide
            </Link>
            <Link to="/play" className={`px-3 py-2 rounded-lg ${linkClass("/play")}`}>
              Jouer
            </Link>
          </div>

          {/* Séparateur */}
          <div className="h-5 w-px bg-slate-200 mx-1" />

          {/* Scoreboards — discret, toujours accessible */}
          <Link
            to="/scoreboards"
            className="px-3 py-2 rounded-lg text-sm text-slate-400 hover:text-slate-700 transition"
            title="Classements"
          >
            Scores
          </Link>

          {/* Séparateur */}
          <div className="h-5 w-px bg-slate-200 mx-1" />

          {/* Auth */}
          {!token && (
            <>
              <Link
                to="/signup"
                className="px-3 py-2 rounded-lg text-sm text-slate-700 hover:text-indigo-600 transition"
              >
                Inscription
              </Link>
              <Link
                to="/login"
                className="ml-1 inline-flex items-center px-4 py-2 rounded-full bg-indigo-600 text-white text-sm font-semibold hover:bg-indigo-500 transition shadow-sm"
              >
                Connexion
              </Link>
            </>
          )}

          {token && (
            <>
              <Link
                to="/profile"
                className="ml-1 inline-flex items-center px-4 py-2 rounded-full border border-slate-300 text-slate-800 text-sm font-medium hover:border-indigo-400 hover:text-indigo-700 transition"
              >
                Mon espace
              </Link>
              <button
                onClick={handleLogout}
                className="ml-1 px-3 py-2 rounded-lg text-sm text-rose-500 hover:text-rose-600 transition"
              >
                Déconnexion
              </button>
            </>
          )}
        </div>

        {/* Hamburger mobile */}
        <button
          onClick={() => setIsOpen((o) => !o)}
          className="md:hidden inline-flex items-center justify-center rounded-lg p-2 text-slate-700 hover:bg-slate-100 focus:outline-none transition"
          aria-label="Ouvrir le menu"
        >
          <span className="text-xl">{isOpen ? "✕" : "☰"}</span>
        </button>
      </div>

      {/* Menu mobile */}
      {isOpen && (
        <div className="md:hidden border-t border-slate-200 bg-white">
          <div className="px-4 py-4 space-y-1 text-sm">
            {[
              { to: "/", label: "Accueil" },
              { to: "/catalogue", label: "Catalogue" },
              { to: "/offres", label: "Tarifs" },
              { to: "/guide", label: "Guide" },
              { to: "/play", label: "Jouer" },
              { to: "/scoreboards", label: "Scores & classements" },
            ].map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className={`block px-3 py-2 rounded-lg ${isActive(to) ? "text-indigo-600 font-semibold bg-indigo-50" : "text-slate-700 hover:text-indigo-600 hover:bg-slate-50"}`}
                onClick={() => setIsOpen(false)}
              >
                {label}
              </Link>
            ))}

            <div className="h-px bg-slate-200 my-2" />

            {!token && (
              <>
                <Link
                  to="/signup"
                  className="block px-3 py-2 rounded-lg text-slate-700 hover:text-indigo-600 hover:bg-slate-50"
                  onClick={() => setIsOpen(false)}
                >
                  Inscription
                </Link>
                <Link
                  to="/login"
                  className="mt-1 inline-flex items-center px-4 py-2 rounded-full bg-indigo-600 text-white font-semibold hover:bg-indigo-500 transition"
                  onClick={() => setIsOpen(false)}
                >
                  Connexion
                </Link>
              </>
            )}

            {token && (
              <>
                <Link
                  to="/profile"
                  className="block px-3 py-2 rounded-lg text-slate-700 hover:text-indigo-600 hover:bg-slate-50"
                  onClick={() => setIsOpen(false)}
                >
                  Mon espace
                </Link>
                <button
                  onClick={() => { setIsOpen(false); handleLogout(); }}
                  className="block w-full text-left px-3 py-2 rounded-lg text-rose-500 hover:text-rose-600 hover:bg-rose-50"
                >
                  Déconnexion
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;